import { render, staticRenderFns } from "./Biblia.vue?vue&type=template&id=1ce1161d"
import script from "./Biblia.vue?vue&type=script&lang=js"
export * from "./Biblia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports